import { makeStyles } from '@material-ui/core/styles';

// Per the Figma "Modal" frame (#34591 PR feedback): 40x34 alert, H1 title, Body1 copy spanning the
// content width, then 36px hug-width buttons 8px apart, right-aligned, 32px below the copy.
export default makeStyles((theme) => ({
  // MUI forces DialogContent's first-child paddingTop to 20px; add the rest so the icon sits 48px
  // below the modal top like the other content edges.
  alertIcon: {
    display: 'block',
    width: 40,
    height: 34,
    marginTop: theme.spacing(7)
  },
  title: {
    lineHeight: 1.4,
    margin: theme.spacing(6, 0, 4)
  },
  body: {
    lineHeight: '24px',
    color: theme.colorPalette.green_80
  },
  buttons: {
    marginTop: theme.spacing(8),
    gap: theme.spacing(2)
  },
  button: {
    height: 36,
    minWidth: 0,
    padding: theme.spacing(2, 4),
    fontSize: 14,
    fontWeight: 600
  }
}));
